export default __webpack_public_path__ + "static/right-4e65fe4fac11b52762fea1355ec804e0.png";